import { Component } from '@angular/core';
import { ProviderDashboardComponent } from '../dashboard/dashboard.component';

@Component({
  selector: 'app-provider-home',
  standalone: true,
  imports: [ProviderDashboardComponent],
  template: '<app-provider-dashboard></app-provider-dashboard>',
})
export class ProviderHomeComponent {
  // Home component acts as an entry point that renders the dashboard component
}
